import { render } from "./Frecuencia.vue?vue&type=template&id=5716ee3a&scoped=true"
import script from "./Frecuencia.vue?vue&type=script&lang=js"
export * from "./Frecuencia.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=5716ee3a&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5716ee3a"]])

export default __exports__